import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Checkin from "./Checkin";

function App() {
  return (
    <Router basename={"/"}>
      <Routes>
        <Route path="/" element={<Checkin></Checkin>} />
      </Routes>
    </Router>
  );
}

export default App;
